import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/keywords',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/keywords',
      name: 'keywords',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/Keyword.vue')
    }

  ]
};
export default app;
